import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  namespaced:true,
  state: {
    token: localStorage.getItem('token') || null,
    user: {},
    role_modules: null
  },
  actions,
  mutations,
  getters
}